// services/facturaService.js

import api from './api';

// ====================================
// FACTURAS
// ====================================

export const obtenerFacturas = async (filtros = {}) => {
  const params = new URLSearchParams(filtros).toString();
  const response = await api.get(`/facturas?${params}`);
  return response.data;
};

export const obtenerFactura = async (id) => {
  const response = await api.get(`/facturas/${id}`);
  return response.data;
};

export const crearFactura = async (datos) => {
  const response = await api.post('/facturas', datos);
  return response.data;
};

export const emitirFactura = async (id) => {
  const response = await api.post(`/facturas/${id}/emitir`);
  return response.data;
};

export const anularFactura = async (id, motivo) => {
  const response = await api.post(`/facturas/${id}/anular`, { motivo });
  return response.data;
};

export const obtenerDashboardCuentasPorCobrar = async () => {
  const response = await api.get('/facturas/dashboard');
  return response.data;
};

// ====================================
// PAGOS
// ====================================

export const registrarPago = async (datos) => {
  const response = await api.post('/pagos', datos);
  return response.data;
};

export const obtenerPagosFactura = async (facturaId) => {
  const response = await api.get(`/pagos/factura/${facturaId}`);
  return response.data;
};

export const obtenerHistorialPagos = async (filtros = {}) => {
  const params = new URLSearchParams(filtros).toString();
  const response = await api.get(`/pagos/historial?${params}`);
  return response.data;
};

// ====================================
// CONFIGURACIÓN
// ====================================

export const toggleModuloFacturacion = async (activar) => {
  const response = await api.post('/configuracion/toggle-facturacion', { activar });
  return response.data;
};